import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'

/** Separate Yandex Metrika counters some salons have for their own page */
const SALON_COUNTERS: Record<number, string> = {
  91: '91309700',
  43: '91085603',
  87: '91083006',
  97: '92257989',
  142: '96438552',
  44: '112879798',
}

export const SalonMetrika: React.FC<{ salonId: number }> = ({ salonId }) => {
  const id = SALON_COUNTERS[salonId]
  if (!id) {
    return null
  }
  return (
    <Helmet>
      <script type="text/javascript">
        {`
(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
m[i].l=1*new Date();
for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(${id}, "init", {
clickmap:true,
trackLinks:true,
accurateTrackBounce:true,
webvisor:true
});`}
      </script>
    </Helmet>
  )
}
